'use client'

import { phantomProvider, readInt } from "./actionsSol.ts";
import base58_to_binary from "./crypto/base58_to_binary.ts";
import binary_to_base58 from "./crypto/binary_to_base58.mjs";
import { BackpackWindow } from "./wallets.ts";
import AnchorLink from "./wallets/anchor-link";
import AnchorLinkBrowserTransport from "./wallets/anchor-link-browser-transport"
import { Api, JsonRpc, RpcError } from 'eosjs/dist/index';
import { JsSignatureProvider } from 'eosjs/dist/eosjs-jssig.js';
import * as nacl from "tweetnacl-ts"
import { phantomAPP } from "./definitions.ts";

  export type verifyPayload = {
      sig:string
      tx:string|null;
  }

  export async function getPhantomPayload(nonce:string):Promise<verifyPayload | null>{
        let phantomProvider = null;

        if ('phantom' in window) {
          const phantom:phantomProvider = window.phantom as phantomProvider;

          if(phantom !== null){
            const provider = phantom.solana;
            if (provider?.isPhantom) {
              phantomProvider = provider;
            }
          }
        }

        if(!phantomProvider){

            alert('cannot connect phantom wallet');
            return null;
        }

        const encodedMessage = new TextEncoder().encode(nonce);
        const signedMessage = await phantomProvider.signMessage(encodedMessage, "utf8");
        const signedMessage58 = binary_to_base58(signedMessage.signature);
        return { tx: null, sig: signedMessage58 };
  }

  export function getSignUrl(sessID:string, phantomInfos: phantomAPP, sessionNonce:string):string{

    //.phantomSession, props.blockchaininfos.phantomPK, props.blockchaininfos.sharedSK, props.blockchaininfos.sharedPK
        const pSession = JSON.parse(phantomInfos.phantomSession);
        const bNonce = new TextEncoder().encode(sessionNonce);
        const msg = {
            "message": binary_to_base58(bNonce), // the message, base58 encoded
            "session": pSession.session, // token received from connect-method
            "display": "hex", // the encoding to use when displaying the message 
        }
        const bmsg = new TextEncoder().encode(JSON.stringify(msg));

        let nonce = new Uint8Array(24);
        for (let n = 0; n < 24; n++) {
            nonce[n] = Math.random() * 255;
        }
        const encNonce = binary_to_base58(nonce);

        const encrypted = nacl.box(bmsg, nonce, new Uint8Array(phantomInfos.phantomPK), new Uint8Array(phantomInfos.sharedSk));
        const benc = binary_to_base58(encrypted);


        let baseURL = 'https://phantom.app/ul/v1/signMessage?';
        baseURL += "dapp_encryption_public_key="+binary_to_base58(phantomInfos.sharedPK);
        baseURL += "&nonce="+encNonce;
        baseURL += "&redirect_link="+phantomInfos.siteURL+'/api/PhantomVerify?sessID='+sessID;
        baseURL += "&payload="+benc;
        return baseURL;
    }



  declare const window: BackpackWindow;

  export async function getBackPackPayload(nonce:string):Promise<verifyPayload | null>{
        let backpack = null;

        if ('backpack' in window) {
          backpack = window.backpack;

        }
        if(!backpack){

            alert('cannot connect phantom wallet');
            return null;
        }

        const encodedMessage = new TextEncoder().encode(nonce);
        const signedMessage = await backpack.signMessage(encodedMessage);
        const signedMessage58 = binary_to_base58(signedMessage.signature);
        return { tx: null, sig: signedMessage58 };
  }


    export async function validateAnchor(ep:string, chainId:string,contract:string, account:string|null, nonce:string):Promise<verifyPayload | null>{

      if(!account)
        return null;

      const transport = new AnchorLinkBrowserTransport();
      const link = new AnchorLink({ transport, chains: [{ chainId: chainId, nodeUrl: ep }] });

      if(!link){
        console.log('validateAnchor: no link')
        return null;
      }

      const n = base58_to_binary(nonce).subarray(0, 4);
      const non = readInt(Buffer.from(n));

      const textEncoder = new TextEncoder();
      const textDecoder = new TextDecoder();


      const signatureProvider = new JsSignatureProvider([]);
      const rpc = new JsonRpc(ep, { fetch });
      const eos = new Api({ rpc, signatureProvider, textDecoder, textEncoder });
    
      const TxData = { actions: [{ account: contract, name: "walletcheck", authorization: [{ actor: account, permission: "active" }], data: { caller: account, signing_value: non, assoc_id: non } }] };
      const TxOptions = { blocksBehind: 3, expireSeconds: 30, broadcast: false, sign: true };
      const result = await link.transact(TxData, TxOptions, transport);
      const s= JSON.stringify(result.transaction);
      const t = JSON.parse(s);
      const serializedTransation = eos.serializeTransaction(t);
      return { tx: binary_to_base58(serializedTransation), sig: btoa(JSON.stringify(result.signatures)) };
    }
        
    export async function validateWax(wax: any | null,contract:string, account:string | null, nonce:string):Promise<verifyPayload | null>{
        if(!account)
          return null;

        if(!wax)
          return null;


        const n = base58_to_binary(nonce).subarray(0, 4);
        const non = readInt(Buffer.from(n));

        const TxData = { actions: [{ account: contract, name: "walletcheck", authorization: [{ actor: account, permission: "active" }], data: { caller: account, signing_value: non, assoc_id: non } }] };
        const TxOptions = { blocksBehind: 3, expireSeconds: 30, broadcast: false, sign: true };
        const result = await wax.api.transact(TxData, TxOptions);
        return { tx: binary_to_base58(result.serializedTransaction), sig: btoa(JSON.stringify(result.signatures)) };
    }